module.exports = __webpack_public_path__ + "img/37.751a1548.jpg";